<template>
  <div class="aaccountNumberDescription">
    <van-search v-model="value" placeholder="输入城市查询是否支持(例如输入北京市)"  right-icon="location-o" v-on:clickRightIcon="aearFn(1)"/>

    <van-tabs v-model:active="active">
      <van-tab :title="item.name" v-for="(item,key) in city" :key="key">
          <div class="centent">
            <h2>{{item.h2}}</h2>
            <h4>
              {{item.h4}}
              <h4>
                <div class="list">
                    <div :class="{item:true,'item-active':area.indexOf(value) != -1}" :id="'id' + key + k" v-for="(area,k) in item.centont.split(' ')" :key='k'>
                      {{area}}
                    </div>
                </div>
              </h4>
            </h4>
          </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  name: 'AaccountNumberDescription',
  data(){
    return{
      city:[
        {
          centont:'北京市 牡丹江市 信阳市 河池市 天津市 南京市 武汉市 来宾市 石家庄 徐州市 十堰市 崇左市 唐山市 镇江市 宜昌市 儋州市 邯郸市 泰州市 襄阳市 重庆市 邢台市 杭州市 孝感市 保山市 保定市 芜湖市 荆州市 西安市 张家口 淮南市 黄冈市 固原市 衡水市 安庆市 随州市 中卫市 临汾市 黄山市 天门市 呼和浩特 宿州市 株洲市 包头市 六安市 湘潭市 赤峰市 南昌市 张家界市 鄂尔多斯市 赣州市 益阳市 沈阴市 抚州市 广州市 大连市 上饶市 深圳市 抚顺市 济南市 江门市 丹东市 东营市 茂名市 锦州市 烟台市 梅州市 辽阳市 潍坊市 汕尾市 长春市 济宁市 云浮市 哈尔滨市 泰安市 南宁市 齐齐哈尔市 威海市 梧州市 双鸭山市 德州市 防城港市 大庆市 聊城市 钦州市 伊春市 滨州市 贵港市 佳木斯市 菏泽市 玉林市 七台河市 南阳市 百色市',
          h2:'中燃气专线，仅支持中中国燃气 和 中燃集团 用户下单。',
          h4:'目前仅支持以下城市：',
          name:'中国燃气'
        },
        {
          centont:'北燃港华:北京市北京市-北燃港华 秦皇岛港华:河北省秦皇岛市-秦皇岛港华 沧县港华:河北省沧州市-沧县港华 孟村港华:河北省沧州市-孟村港华 盐山港华:河北省沧州市-盐山港华 景县港华:河北省衡水市-景县港华 包头港华:内蒙古自治区包头市-包头港华 沈阳港华:辽宁省沈阳市-沈阳港华 营口港华:辽宁省营口市-营口港华 朝阳港华燃气:辽宁省朝阳市-朝阳港华燃气 吉林港华:吉林省吉林市-吉林港华 齐齐哈尔港华:黑龙江省齐齐哈尔市-齐齐哈尔港华 齐齐哈尔港华（昂昂溪区）:黑龙江省齐齐哈尔市-齐齐哈尔港华（昂昂溪区） 齐齐哈尔港华富区:黑龙江省齐齐哈尔市-齐齐哈尔港华富区 高淳港华:江苏省南京市-高淳港华 宜兴港华:江苏省宜兴市-宜兴港华 沛县港华燃气:江苏省徐州市-沛县港华燃气 铜山港华:江苏省徐州市-铜山港华 睢宁港华:江苏省徐州市-睢宁港华 丰县港华:江苏省徐州市-丰县港华 徐州港华:江苏省徐州市-徐州港华 常州金坛港华燃气有限公司:江苏省常州市-常州金坛港华燃气有限公司 苏州港华:江苏省苏州市-苏州港华 吴江港华:江苏省苏州市-吴江港华 张家港港华燃气:江苏省张家港市-张家港港华燃气 丹阳港华:江苏省镇江市-丹阳港华 泰州港华燃气:江苏省泰州市-泰州港华燃气 泰州永安港华:江苏省泰州市-泰州永安港华 杭州港华:浙江省杭州市-杭州港华 桐乡港华:浙江省嘉兴市-桐乡港华 湖州港华燃气:浙江省湖州市-湖州港华燃气 松阳港华:浙江省丽水市-松阳港华 芜湖港华:安徽省芜湖市-芜湖港华 芜湖江北港华:安徽省芜湖市-芜湖江北港华 博望港华:安徽省马鞍山市-博望港华 马鞍山江北港华:安徽省马鞍山市-马鞍山江北港华 马鞍山港华:安徽省马鞍山市-马鞍山港华 铜陵港华:安徽省铜陵市-铜陵港华 黄山港华燃气:安徽省黄山市-黄山港华燃气 徽州港华燃气:安徽省黄山市-徽州港华燃气 太平港华燃气:安徽省黄山市-太平港华燃气 池州港华:安徽省池州市-池州港华 青阳港华:安徽省池州市-青阳港华 长汀港华:福建省龙岩市-长汀港华 萍乡港华:江西省萍乡市-萍乡港华 德安港华:江西省九江市-德安港华 永修港华:江西省九江市-永修港华 共青城港华:江西省九江市-共青城港华 庐山港华:江西省九江市-庐山港华 丰城港华:江西省宜春市-丰城港华 樟树港华:江西省宜春市-樟树港华 平阴港华:山东省济南市-平阴港华 汉岳燃气:山东省济南市-汉岳燃气 东亿港华:山东省青岛市-东亿港华 青岛中即港华:山东省青岛市-青岛中即港华 龙口港华燃气:山东省烟台市-龙口港华燃气 莱阳港华:山东省莱阳市-莱阳港华 招远港华:山东省招远市-招远港华 临朐港华:山东省潍坊市-临朐港华 潍坊港华燃气:山东省潍坊市-潍坊港华燃气 肥城港华:山东省泰安市-肥城港华 泰山港华:山东省泰安市-泰山港华 威海港华燃气:山东省威海市-威海港华燃气 威海港华燃气文登分公司:山东省威海市-威海港华燃气文登分公司 五莲港华:山东省日照市-五莲港华 茌平港华:山东省聊城市-茌平港华 阳信港华:山东省滨州市-阳信港华 博兴港华:山东省滨州市-博兴港华 新密港华:河南省郑州市-新密港华 汨罗港华燃气:湖南省岳阳市-汨罗港华燃气 东永港华:广东省广州市-东永港华 韶关港华:广东省韶关市-韶关港华 阳江港华:广东省阳江市-阳江港华 清远港华:广东省清远市-清远港华 中山港华燃气:广东省中山市-中山港华燃气 中山小榄港华:广东省中山市-中山小榄港华 柳州港华:广西壮族自治区柳州市-柳州港华 桂林港华:广西壮族自治区桂林市-桂林港华 重庆港华:重庆市重庆市-重庆港华 成都新都港华燃气:四川省成都市-成都新都港华燃气 大邑港华燃气:四川省成都市-大邑港华燃气 简阳港华燃气:四川省成都市-简阳港华燃气 新津港华燃气:四川省成都市-新津港华燃气 绵竹港华:四川省德阳市-绵竹港华 绵竹玉泉港华:四川省德阳市-绵竹玉泉港华 中江港华燃气:四川省德阳市-中江港华燃气 绵阳河清港华:四川省绵阳市-绵阳河清港华 绵阳港华燃气:四川省绵阳市-绵阳港华燃气 三台港华:四川省绵阳市-三台港华 绵阳三台东昇港华:四川省绵阳市-绵阳三台东昇港华 苍溪港华燃气:四川省广元市-苍溪港华燃气 蓬溪港华燃气:四川省遂宁市-蓬溪港华燃气 威远港华:四川省内江市-威远港华 夹江港华:四川省乐山市-夹江港华 彭山港华燃气:四川省眉山市-彭山港华燃气 岳池港华:四川省广安市-岳池港华 平昌港华燃气:四川省巴中市-平昌港华燃气 乐至港华:四川省资阳市-乐至港华 资阳港华燃气:四川省资阳市-资阳港华燃气 兴义港华:贵州省兴义市-兴义港华 陆良港华:云南省曲靖市-陆良港华',
          h2:'注意事项：用户提单充值前，绑定时刻家app或是微信小程序截图余额记录，方便后面对账。',
          h4:'以下是港华燃气支持城市：',
          name:'港华燃气'
        },
        {
          centont:'迁安市:河北省-迁安市 邯郸市:河北省-邯郸市 衡水市:河北省-衡水市 衡水市:河北省-衡水市 大同市:山西省-大同市 长治市:山西省-长治市 赤峰市:内蒙古自治区-赤峰市 海城市:辽宁省-海城市 本溪市:辽宁省-本溪市 本溪市:辽宁省-本溪市 丹东市:辽宁省-丹东市 辽阳市:辽宁省-辽阳市 盘锦市:辽宁省-盘锦市 辽源市:吉林省-辽源市 上海市:上海市-上海市 南京市:江苏省-南京市 苏州市:江苏省-苏州市 昆山市:江苏省-昆山市 南通市:江苏省-南通市 启东市:江苏省-启东市 盐城市:江苏省-盐城市 泰州市:江苏省-泰州市 宿迁市:江苏省-宿迁市 杭州市:浙江省-杭州市 宁波市:浙江省-宁波市 慈溪市:浙江省-慈溪市 乐清市:浙江省-乐清市 金华市:浙江省-金华市 台州市:浙江省-台州市 临海市:浙江省-临海市 丽水市:浙江省-丽水市 淮北市:安徽省-淮北市 福州市:福建省-福州市 福州市:福建省-福州市 福州市:福建省-福州市 福州市:福建省-福州市 福州市:福建省-福州市 福州市:福建省-福州市 福州市:福建省-福州市 福清市:福建省-福清市 厦门市:福建省-厦门市 南平市:福建省-南平市 龙岩市:福建省-龙岩市 鹰潭市:江西省-鹰潭市 贵溪市:江西省-贵溪市 吉安市:江西省-吉安市 吉安市:江西省-吉安市 吉安市:江西省-吉安市 吉安市:江西省-吉安市 吉安市:江西省-吉安市 抚州市:江西省-抚州市 济南市:山东省-济南市 淄博市:山东省-淄博市 枣庄市:山东省-枣庄市 滕州市:山东省-滕州市 东营市:山东省-东营市 莱州市:山东省-莱州市 潍坊市:山东省-潍坊市 潍坊市:山东省-潍坊市 青州市:山东省-青州市 安丘市:山东省-安丘市 济宁市:山东省-济宁市 济宁市:山东省-济宁市 济宁市:山东省-济宁市 临沂市:山东省-临沂市 禹城市:山东省-禹城市 郑州市:河南省-郑州市 郑州市:河南省-郑州市 登封市:河南省-登封市 洛阳市:河南省-洛阳市 安阳市:河南省-安阳市 安阳市:河南省-安阳市 安阳市:河南省-安阳市 安阳市:河南省-安阳市 鹤壁市:河南省-鹤壁市 濮阳市:河南省-濮阳市 濮阳市:河南省-濮阳市 南阳市:河南省-南阳市 南阳市:河南省-南阳市 商丘市:河南省-商丘市 武汉市:湖北省-武汉市 武汉市:湖北省-武汉市 武汉市:湖北省-武汉市 武汉市:湖北省-武汉市 武汉市:湖北省-武汉市 大冶市:湖北省-大冶市 襄阳市:湖北省-襄阳市 襄阳市:湖北省-襄阳市 枣阳市:湖北省-枣阳市 宜城市:湖北省-宜城市 钟祥市:湖北省-钟祥市 潜江市:湖北省-潜江市 长沙市:湖南省-长沙市 岳阳市:湖南省-岳阳市 郴州市:湖南省-郴州市 娄底市:湖南省-娄底市 冷水江市:湖南省-冷水江市 湘西土家族苗族自治州:湖南省-湘西土家族苗族自治州 汕头市:广东省-汕头市 江门市:广东省-江门市 江门市:广东省-江门市 开平市:广东省-开平市 肇庆市:广东省-肇庆市 惠州市:广东省-惠州市 兴宁市:广东省-兴宁市 河源市:广东省-河源市 阳江市:广东省-阳江市 中山市:广东省-中山市 柳州市:广西壮族自治区-柳州市 成都市:四川省-成都市 成都市:四川省-成都市 彭州市:四川省-彭州市 攀枝花市:四川省-攀枝花市 泸州市:四川省-泸州市 什邡市:四川省-什邡市 内江市:四川省-内江市 隆昌市:四川省-隆昌市 达州市:四川省-达州市 达州市:四川省-达州市 达州市:四川省-达州市 万源市:四川省-万源市 巴中市:四川省-巴中市 清镇市:贵州省-清镇市 昆明市:云南省-昆明市 楚雄彝族自治州:云南省-楚雄彝族自治州 西宁市:青海省-西宁市 海东市:青海省-海东市 格尔木市:青海省-格尔木市',
          h2:'注意事项：用户提单充值前，绑定时刻家app或是微信小程序截图余额记录，方便后面对账。',
          h4:'以下是华润燃气支持城市：',
          name:'华润燃气'
        }
      ],
      active_key:undefined,
      value:undefined,
      city_index:undefined,
      active:0
    }
  },
  created(){
      
  },
  watch:{
    'value':function(newValue,oldValue){
      let arr = this.city[this.active].centont.split(' ');
        for (var key in arr) {
          if(arr[key] == newValue){
            document.querySelector('#id'+this.active + key).scrollIntoView();
          }
        }
    }
  },
  methods:{
    aearFn(i){
        this.show = true;
        console.log("获取定位");
        AMapLoader.load({
            "key": "2d4144b5959c0681cdcd635488dae29e",              // 申请好的Web端开发者Key，首次调用 load 时必填
            "version": "1.4.15",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            "plugins": [],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            "AMapUI": {             // 是否加载 AMapUI，缺省不加载
                "version": '1.1',   // AMapUI 缺省 1.1
                "plugins":[],       // 需要加载的 AMapUI ui插件
            }
        }).then((AMap)=>{
            AMap.plugin('AMap.Geolocation', ()=>{
              let geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                timeout: 10000,
                // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                buttonOffset: new AMap.Pixel(10, 20)
              })

              geolocation.getCurrentPosition((status,result)=>{
                this.show = false;
                    if(status=='complete'){
                        // result是具体的定位信息
                        this.value = result.addressComponent.city;

                    }else{
                        // 定位出错
                        this.$toast.fail('定位失败请自行输入地区');
                        console.log("定位失败",result);
                    }
              });
            })
        }).catch(e => {
            console.log(e);
        })
      }
  }
}
</script>
<style scoped>
.centent{
  margin: 10px;
}
.list{
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.item{
  flex: 1;
  max-width: calc(20% - 2px);
  min-width: calc(20% - 2px);
  text-align: center;
  margin: 10px 0;
  padding: 10px 0;
  border: 1px solid #cccccc;
  background-color: rgba(219,219,219, .5);
}
.item-active{
  flex: 1;
  max-width: calc(20% - 2px);
  min-width: calc(20% - 2px);
  text-align: center;
  margin: 10px 0;
  padding: 10px 0;
  border: 1px solid #cccccc;
  background-color: rgba(219, 219, 219, 0.5);
  color: red;
}
</style>
